var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ios-barcode"},[_c('p',{staticClass:"text-center text-secondary"},[_vm._v("如果手機連接條碼掃描器後無法開啟輸入法，請使用條碼掃描器掃描下面的條碼。")]),_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":require('@/assets/imgs/barcode.png')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }